import * as React from 'react'
import {createErrorHandlingForm, ErrorHandlingFormProps} from './hoc/createErrorHandlingForm'
import {Box, IconButton} from '@mui/material'
import styled from 'styled-components'
import {Clear} from '@mui/icons-material'

interface TagProps {
    text: string
    onClickClearButton?: () => void
    className?: string
}

const PPTag = (props: TagProps & ErrorHandlingFormProps) => {
    const {text, onClickClearButton, className, hasError} = props
    return <Tag hasError={hasError} className={className}>
        {text}
        {onClickClearButton &&
        <>
            <Box width={40}/>
            <IconButton
                size={'small'}
                onClick={onClickClearButton}
            >
                <Clear/>
            </IconButton>
        </>
        }
    </Tag>
}
PPTag.displayName = 'PPTag'
export default createErrorHandlingForm(PPTag)

const Tag = styled.div<{ hasError?: boolean }>`
  width: 100%;
  padding: 4px 8px 4px 16px;
  background: ${props => props.hasError ? '#F7D7DB;' : '#F1F1F1;'}
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`
